import React from 'react';
import cx from 'classnames';

// @ts-ignore
import LiveUpdateIcon from '../../images/icons/cell_tower.svg';
// @ts-ignore
import LiveUpdateFailedToConnectIcon from '../../images/icons/cell_tower_failed.svg';

import { TestID } from '../../testID';

import './LiveUpdatesHeaderIndicator.scss';

export const LiveUpdatesHeaderIndicator: React.FC<{
  isLiveUpdatesEnabled?: boolean;
  isLiveUpdatesSupported?: boolean;
  failedToConnectToLiveUpdates?: boolean;
}> = ({ isLiveUpdatesEnabled, isLiveUpdatesSupported, failedToConnectToLiveUpdates }) => {
  const failedToConnect = isLiveUpdatesSupported && failedToConnectToLiveUpdates;

  const supportedTitle =
    isLiveUpdatesSupported === false
      ? 'Live updates is not supported for this subscription'
      : `Live updates ${isLiveUpdatesEnabled ? 'enabled' : 'disabled'}`;

  const failedToConnectTitle = 'Failed to connect to Live updates';

  return (
    <div
      className={cx(
        'live-updates-indicator-wrapper',
        failedToConnectToLiveUpdates === true && 'failed'
      )}
      title={failedToConnect ? failedToConnectTitle : supportedTitle}
      data-testid={TestID.LiveUpdatesIndicatorWrapper}
    >
      {failedToConnect ? (
        <LiveUpdateFailedToConnectIcon
          className={cx('live-updates-indicator failed')}
          data-testid={TestID.LiveUpdatesIndicator}
        />
      ) : (
        <LiveUpdateIcon
          className={cx(
            'live-updates-indicator',
            isLiveUpdatesEnabled && isLiveUpdatesSupported && 'enabled',
            isLiveUpdatesSupported === false && 'disabled'
          )}
          data-testid={TestID.LiveUpdatesIndicator}
        />
      )}
    </div>
  );
};
